module.exports = __webpack_public_path__ + "img/20.139ddc39.jpg";